import { render } from "./online-canvas.vue?vue&type=template&id=2619814d&scoped=true"
import script from "./online-canvas.vue?vue&type=script&lang=js"
export * from "./online-canvas.vue?vue&type=script&lang=js"

import "./online-canvas.vue?vue&type=style&index=0&id=2619814d&lang=scss&scoped=true"

import exportComponent from "C:\\Work\\Projects\\CableLab\\main\\CableLab\\UsbDeviceDriver\\html\\command-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2619814d"],['__file',"src/submodules/visualizator-common-components/vue/online/online-canvas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2619814d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2619814d', __exports__)) {
    api.reload('2619814d', __exports__)
  }
  
  module.hot.accept("./online-canvas.vue?vue&type=template&id=2619814d&scoped=true", () => {
    api.rerender('2619814d', render)
  })

}


export default __exports__